//Reset data
export const RESET = "PARAMETRE_DEL_RESET"



//Loading
export const SET_TOGGLE_LOADING = "PARAMETRE_DEL_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "PARAMETRE_DEL_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "PARAMETRE_DEL_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "PARAMETRE_DEL_SET_MESSAGE"
export const SET_IS_SUCCESS = "PARAMETRE_DEL_SET_IS_SUCCESS"
export const SET_IS_ERROR = "PARAMETRE_DEL_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "PARAMETRE_DEL_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "PARAMETRE_DEL_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "PARAMETRE_DEL_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "PARAMETRE_DEL_SET_ITEMS"
export const SET_CURRENT_ITEM = "PARAMETRE_DEL_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "PARAMETRE_DEL_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "PARAMETRE_DEL_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "PARAMETRE_DEL_SET_HIDE_MODAL"


export const SET_MODAL = "PARAMETRE_DEL_SET_MODAL"
export const SET_MODAL_CONTENT = "PARAMETRE_DEL_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "PARAMETRE_DEL_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "PARAMETRE_DEL_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "PARAMETRE_DEL_SET_MODAL_TYPE"
export const SET_MODAL_IS_UPDATE = "PARAMETRE_DEL_SET_IS_UPDATE"